<template>
    <div class="">
        <b-container fluid>
            <h1>HRM User Search</h1>

            <b-row>
                <b-col cols="12" lg="4">
                  <BaseSelector v-model="criteria.role"
                    :v="$v.criteria.role"
                    slug="role"
                    label="Role"
                    :options = roles
                  />
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseEmployeeSelector v-model="criteria.person"
                                          label="User"
                                          :v="$v.criteria.person"
                                          slug="person"
                                          tip=""
                                          :showPcn="false"/>
                </b-col>
            </b-row>
            <hr/>
            <b-row class="mb-3">
              <b-col>
                <b-button type="button" variant="primary" @click="search">
                    <b-spinner small v-show="loading" class="mr-2"></b-spinner>Search</b-button>
                    <b-button type="button" variant="secondary" @click="clear">Clear</b-button>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                  <b-table hover small responsive show-empty
                           :fields="fields"
                           :items="results"
                           :busy="loading">
                      <template #table-caption></template>
                      <template v-slot:cell(actions)="row">
                          <b-button size="sm" @click="manage(row.item)" class="mr-1">
                              manage roles
                          </b-button>
                      </template>
                      <template v-slot:no-data>
                          <p>No users found.</p>
                      </template>

                      <template v-slot:empty="scope">
                          <p>No users found.</p>
                      </template>

                      <div slot="table-busy" class="text-center text-danger my-2">
                          <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
                          <strong>Loading, Please Wait...</strong>
                      </div>

                  </b-table>
              </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from "axios"
import { commonOptions } from '@/mixins/commonOptions.js'
import BaseSelector from "@/components/BaseSelector";

export default {
  title: 'HRM User Search',
  data: () => ({
    loading: false, 
    loadingDownload: false,

    filter: null,

    criteria: {
      role: null,
      person: null,
    },
    results: [],
    fields: [
        {key: 'userId', sortable: true, label: 'UserId'},
        {key: 'name', sortable: true, label: 'Name'},
        {key: 'actions', label: 'Actions'},
    ],
  }),
  components: {
      BaseSelector,
  },
  mixins: [
    commonOptions,
  ],
  validations: {
    criteria: {
      role: { required: false },
      person: { required: false },
    }
  },
  methods: {
    clear() {
        this.criteria = {
            role: null,
            person: null,
        }
        this.results = []
    },
    search() {
          this.loading = true
          this.results = []
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/roles/search/user`, this.criteria)
          .then(response => { 
            this.results = response.data
            this.loading = false
          })
    },
    manage(item) {
        console.log(item)
        this.$router.push({ name: 'manageRole', params: { user: item } })
    }
  }
 }
</script>

<style>

</style>